/**
 * Rotas dinamicas baseadas em convencao (views/app/**).
 *
 * - Pega todos os arquivos `.vue` dentro de `src/views/app/` recursivamente
 *   e gera uma rota para cada um.
 * - O path da URL espelha a estrutura de pastas:
 *     views/app/produto/index.vue        -> /app/produto
 *     views/app/produto/cadastro.vue     -> /app/produto/cadastro
 *     views/app/relatorio/vendas.vue     -> /app/relatorio/vendas
 * - Todas as rotas exigem login (`authRequired: true`).
 *
 * Crie uma view dentro de `src/views/app/...` e ela ja estara disponivel.
 * Combinado com o AutoRouter do backend, agentes de IA podem fazer:
 *   1. yarn make create Produto --field "nome:string!" --migration
 *   2. criar src/views/app/produto/index.vue no frontend
 *   3. tudo automaticamente disponivel em /app/produto consumindo /produto da API.
 */

import { PascalCase } from '@/helpers/common/api';

const viewsContext = require.context('../views/app', true, /\.vue$/);

const routes = viewsContext.keys().map((file) => {
  // file ex.: "./produto/index.vue"
  const cleaned = file.replace(/^\.\//, '').replace(/\.vue$/, '');
  // remove "/index" final para que pasta/index.vue vire pasta/
  const path = cleaned.replace(/\/index$/, '');
  const segments = path.split('/');
  const name = segments.join('-') || 'app-home';

  return {
    path: `/app/${path}`,
    name: `app-${name}`,
    component: () => import(/* webpackInclude: /\.vue$/ */ `../views/app/${cleaned}.vue`),
    meta: {
      title: PascalCase(name.replace(/-/g, ' ')),
      authRequired: true,
    },
  };
});

// Remove rotas duplicadas (mesmo path)
const uniquePaths = {};
const FullRoutes = routes.filter((route) => {
  if (uniquePaths[route.path]) return false;
  uniquePaths[route.path] = true;
  return true;
});

export default FullRoutes;
